export default __webpack_public_path__ + "static/media/8400.c0f34880.png";